import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Layer 1 location architecture: current dealer user's access scope + dealer locations.
export function useDealerContext() {
  const [ctx, setCtx] = useState({ me: null, locations: [] });
  useEffect(() => {
    Promise.all([api.get("/auth/me"), api.get("/dealer/profile")])
      .then(([meRes, profRes]) => setCtx({ me: meRes.data, locations: profRes.data?.locations || [] }))
      .catch(() => {});
  }, []);
  const isManager = ctx.me?.location_scope === "location";
  const defaultLoc = ctx.locations.find((l) => l.is_default) || ctx.locations[0] || null;
  const locLabel = (id) => {
    const l = ctx.locations.find((x) => x.id === id);
    return l ? l.label || l.type : null;
  };
  return {
    me: ctx.me,
    locations: ctx.locations,
    isManager,
    myLocationId: isManager ? ctx.me?.location_id : null,
    defaultLocationId: defaultLoc?.id || null,
    showLocationPicker: !isManager && ctx.locations.length > 1,
    locLabel,
  };
}
